frappe.ui.form.ControlAbsInt = class ControlAbsInt extends frappe.ui.form.ControlInt {
	static trigger_change_on_input_event = false;

	make() {
		super.make();
	}

	make_input() {
		var me = this;
		super.make_input();
		this.$input
			.on("focus", function () {
				setTimeout(function () {
					if (!document.activeElement) return;
					if (me.df.fieldtype !== "Currency") {
						// Always show positive value on focus
						document.activeElement.value = Math.abs(me.validate(document.activeElement.value));
						document.activeElement.select();
					}
				}, 100);
				return false;
			});
	}

	validate(value) {
		return this.parse(value);
	}

	eval_expression(value) {
		if (typeof value === "string") {
			if (value.match(/^[0-9+\-/* ]+$/)) {
				// If it is a string containing operators
				try {
					return eval(value);
				} catch (e) {
					// bad expression
					return value;
				}
			}
		}
		return value;
	}

	parse(value) {
		let parsed_value = cint(this.eval_expression(value), null);
		return parsed_value ? -Math.abs(parsed_value) : 0; // Store as negative value
	}

    format_for_input(value) {
		// Always display positive number in the UI
		return value == null ? "" : Math.abs(value);
	}
};

frappe.ui.form.ControlNegativeInt = frappe.ui.form.ControlAbsInt;
